import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-header',
	templateUrl:'./WaPageHeaderProPage.html',
	styles: [],
	styleUrls:['./WaPageHeaderProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageHeaderProPage
{
	mdContent_402 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageHeader;
\`\`\``;
	mdContent_403 = `\`\`\`java
new WaPageHeader<>()
\`\`\``;
}
